<script lang="ts">
  import CartSuccessStore from "@retailer/stores/CartSuccessStore";
  import { redirect } from "@roxi/routify";
  import retailerContext from "@modern/services/retailer_context";
  import Success from "@retailer/svelte/Order/Containers/Success.svelte";

  if (!$CartSuccessStore.orderGroup) {
    $redirect("/cart");
  }

  const retailer = retailerContext.get();

</script>

{#if $CartSuccessStore.orderGroup}
  <Success order={$CartSuccessStore.orderGroup} {retailer} />
{/if}
